import 'react-app-polyfill/ie9';
import 'core-js';
import React from 'react';
import { render } from 'react-dom';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { createLogger } from 'redux-logger';
import { Router } from 'react-router-dom';
import reducer from './reducers';
import { fetchHomeDetails } from './actions/homeActions';
import { fetchCommonDetails } from './actions/commonActions';

import { config } from './env_config/react-config';

import * as serviceWorker from './serviceWorker';
import App from './containers/App';
import PublishStatus from './containers/PublishStatus';
import history from './route/history';
import { globalEventListner } from './utils/index';
import 'jquery/dist/jquery';
import 'popper.js/dist/umd/popper';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap/js/dist/modal';
import './assets/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/media-query.css';

const middleware = [thunk];

if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger());
}

const store = createStore(
  reducer,
  applyMiddleware(...middleware)
);

store.dispatch(fetchHomeDetails(config.retailerId));
store.dispatch(fetchCommonDetails(config.retailerId));

render(
  <Provider store={store}>
      <PublishStatus />
  </Provider>,
  document.getElementById('app')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
globalEventListner();
serviceWorker.register();
